import Editor from './base/editor';
export default Editor.extend({
  width: 300,
  height: 35,
  keysToTriggerClose: [9, 13, 27],
  classNames: ['is-light-theme', 'composer-twitter-follow-button-editor']
});